import React from "react";
import ContentCourse from "./ContentCourse";

function ShortlistedUniver(props) {
  return <ContentCourse />;
}

export default ShortlistedUniver;
